// extracted by mini-css-extract-plugin
module.exports = {"coupon-code":"_2g51KRgGui","button-style":"_1Br7g2wX1J","table-style":"_2ICAPeakbq"};